import PropTypes from 'prop-types';
import React from 'react';
import { TiArrowSortedDown, TiArrowSortedUp } from 'react-icons/ti';

function SortArrow({ direction }) {
  if (direction === 'asc') {
    return (
      <div className="stats-table__sortable-header-arrow">
        <TiArrowSortedUp />
      </div>
    );
  }
  return (
    <div className="stats-table__sortable-header-arrow">
      <TiArrowSortedDown />
    </div>
  );
}

SortArrow.propTypes = {
  direction: PropTypes.string.isRequired,
};

export default SortArrow;
